module.exports = "pegasus/assets/arrow-right.png";